'use strict';

import {changeLangToCurrent, getCurrentLang} from "../components/langSwitcher/langSwitcher";
import { isDesktop, isMobile, isPWA } from '../../settings';
import { Preview } from '../components/preview/Preview';

export class PrivacyAndTerms {
    static #allElements = [];
    static #privacy = null;
    static #terms = null;
    static #privacyElement = null;
    static #termsElement = null;
    #element = document.createElement('div');
    #delimiter = null;

    static #getTerms() {
        if (config.general.eula.length!==0){
            let url = config.general.eula.find(el => el.lang === getCurrentLang())
            if (url){
                url = url.value
            }
            if (!!(url)) return url;
        }
        return `/assets/privacy/${getCurrentLang()}/terms.pdf`;
    }

    static #getPrivacy() {
        let url = config.general.privacyPolicy.find(el => el.lang === getCurrentLang())
        if (url){
            url = url.value;
        }
        if (!!(url)) return url;
        return `/assets/privacy/${getCurrentLang()}/privacy.pdf`;
    }

    static updateItems() {
        PrivacyAndTerms.#terms = PrivacyAndTerms.#getTerms();
        PrivacyAndTerms.#privacy = PrivacyAndTerms.#getPrivacy();

        PrivacyAndTerms.#allElements.forEach((element) => {
           element.querySelector('[data-dictionary="Privacy"]').href = PrivacyAndTerms.#privacy;
           element.querySelector('[data-dictionary="Terms"]').href = PrivacyAndTerms.#terms;
        });
    }

    constructor(args) {
        PrivacyAndTerms.#terms = PrivacyAndTerms.#getTerms();
        PrivacyAndTerms.#privacy = PrivacyAndTerms.#getPrivacy();

        if (!PrivacyAndTerms.#terms && !PrivacyAndTerms.#privacy || isDesktop)
            return;

        PrivacyAndTerms.#allElements.push(this.#element);
        this.#element.classList.add('privacy-and-terms');
        if (isMobile)
            this.#element.classList.add('background-backdrop-filter');
        args.parent.appendChild(this.#element);

        this.#addContent();
    }

    #addContent() {
        if (isMobile) {
            this.#mobileMode();
        } else {
            this.#addItem('Privacy');
            this.#addDelimiter();
            this.#addItem('Terms');

            if (PrivacyAndTerms.#terms && PrivacyAndTerms.#privacy)
                this.#delimiter.classList.remove('hidden');
        }
    }

    #addItem(title, parent = this.#element) {
        if (title === 'Privacy' && !PrivacyAndTerms.#privacy ||
            title === 'Terms' && !PrivacyAndTerms.#terms) return;

        const item = document.createElement('a');
        if (!isMobile)
            item.classList.add('privacy-and-terms__item');
        item.classList.add(
            'aside__navigation-menu__href',
            'language-string',
            'text'
        );
        item.setAttribute('target','_blank');
        item.setAttribute('data-dictionary', title);
        item.addEventListener('click',PrivacyAndTerms.#clickHandler.bind(this));
        item.innerHTML = changeLangToCurrent(title);

        switch (title) {
            case 'Privacy':
                item.href = PrivacyAndTerms.#privacy;
                PrivacyAndTerms.#privacyElement = item;
                break;
            case 'Terms':
                item.href = PrivacyAndTerms.#terms;
                PrivacyAndTerms.#termsElement = item;
                break;
            default:
                console.log('Privacy policy default case in addItem method. Something went wrong');
            break;
        }

        parent.appendChild(item);
    }

    static #clickHandler(e) {
        if (isMobile && isPWA) {
            e.preventDefault();
            const url = new URL(e.target.href);
            new Preview(url.pathname);
        }
    }

    #addDelimiter() {
        this.#delimiter = document.createElement('span');
        this.#delimiter.classList.add('privacy-and-terms__delimiter', 'hidden');
        this.#delimiter.innerHTML = '|';
        this.#element.appendChild(this.#delimiter);
    }

    #mobileMode() {
        const privacyWrapper = document.createElement('div');
        privacyWrapper.classList.add('mobile-menu-item', 'privacy-and-terms__item', 'horizontal-separator');
        const termsWrapper = document.createElement('div');
        termsWrapper.classList.add('mobile-menu-item', 'privacy-and-terms__item');
        const privacyIcon = document.createElement('span');
        privacyIcon.classList.add('privacy-and-terms__icon', 'icon-link-icon');
        const termsIcon = document.createElement('span');
        termsIcon.classList.add('privacy-and-terms__icon', 'icon-link-icon');
        this.#addItem('Privacy', privacyWrapper);
        this.#addItem('Terms', termsWrapper);
        privacyWrapper.appendChild(privacyIcon);
        termsWrapper.appendChild(termsIcon);
        this.#element.appendChild(privacyWrapper);
        this.#element.appendChild(termsWrapper);

        PrivacyAndTerms.#privacyElement.classList.add('body');
        PrivacyAndTerms.#termsElement.classList.add('body');
    }

    show() {
        this.#element.classList.remove('hidden');
    }

    hide() {
        this.#element.classList.add('hidden');
    }

    get() {
        return this.#element;
    }
}
